<template>
    <el-input v-bind="$attrs" v-model="modelValue">
        <template #suffix>
            <el-image
                :src="$attrs.image_base64"
                        style="width: 120px; height: 40px"
                        @click="refreshCaptcha()"
                      >
            </el-image>
        </template>
    </el-input>
</template>

<script>
export default {
    name: "loginCodeInput",
    data() {
        return {
            a: "我是验证码",
        };
    },
    props: {
        value: {
            type: [String, Number],
            default: ""
        },
    },
    computed: {
        modelValue: {
            get({ value, $attrs }) {
                if ($attrs.multiple && !Array.isArray(value)) return [];
                return value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    methods: {
        refreshCaptcha() {
            this.$emit("getCaptcha");
        },
    },
};
</script>

<style lang="scss" scoped>
.code {
    color: $defaultColor;
}
</style>